module.exports = __webpack_public_path__ + "media/img/monster-strong-f633c656.png";